export const CURRENCIES = {
  EUR: `€` as const,
  USD: `$` as const,
  GBP: `£` as const,
  JPY: `¥` as const,
  AUD: `A$` as const,
  CAD: `CA$` as const,
  CHF: `CHF` as const,
  CNY: `CN¥` as const,
  NZD: `NZ$` as const,
  KRW: `₩` as const,
  INR: `₹` as const,
  RUB: `RUB` as const,
  BRL: `R$` as const,
  MXN: `MX$` as const,
  SGD: `SGD` as const
}

export type Currency = keyof typeof CURRENCIES
export const ALLOWED_CURRENCIES = [`EUR`, `USD`, `GBP`, `JPY`, `AUD`, `CAD`, `CHF`, `CNY`, `NZD`, `KRW`, `INR`, `RUB`, `BRL`, `MXN`, `SGD`] as const

export const CURRENCY_OPTIONS = [
  { value: `EUR`, label: `€` },
  { value: `USD`, label: `$` },
  { value: `GBP`, label: `£` },
  { value: `JPY`, label: `¥` },
  { value: `AUD`, label: `A$` },
  { value: `CAD`, label: `CA$` },
  { value: `CHF`, label: `CHF` },
  { value: `CNY`, label: `CN¥` },
  { value: `NZD`, label: `NZ$` },
  { value: `KRW`, label: `₩` },
  { value: `INR`, label: `₹` },
  { value: `RUB`, label: `RUB` },
  { value: `BRL`, label: `R$` },
  { value: `MXN`, label: `MX$` },
  { value: `SGD`, label: `SGD` }
] as { value: Currency; label: string }[]

export const CURRENCY_SYMBOLS = CURRENCY_OPTIONS.map(option => option.label)
